import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers";

const logger = (_) => (next) => (action) => {
  //console.log('dispatching', action)
  var result = next(action);
  //console.log('next state', store.getState())
  return result;
};

const reducer = combineReducers(reducers);
const middlewares = applyMiddleware(thunk, logger);
const store = createStore(reducer, middlewares);

export default store;
